import {
  myFamilyFills,
  myGamesFills,
  myStoryFills,
  myStorySimpleFills,
  myTempleFills,
} from '../../pages/KidsHome/BackgroundFills'
import icons from '../../pages/KidsHome/icons'

export default {
  feed: {
    id: '',
    testId: 'dataTestIdFeed',
    paths: ['/feed'],
    title: 'nav.feed',
    fallbackHeaderImage: '',
    fillColors: null,
    type: 'feed',
  },
  story: {
    id: '20',
    testId: 'dataTestIdMyStory',
    paths: ['/story'],
    title: 'nav.my-story',
    fallbackHeaderImage: icons.person,
    fillColors: myStoryFills,
    simpleFillColors: myStorySimpleFills,
    type: 'story',
  },
  share: {
    id: '20',
    testId: 'dataTestIdShare',
    paths: ['/share'],
    title: '',
    fallbackHeaderImage: null,
    fillColors: null,
    simpleFillColors: null,
    type: 'share',
  },
  activities: {
    id: '',
    testId: 'dataTestIdActivities',
    paths: ['/activities', '/activities/familyavatars'],
    title: 'nav.activities',
    fallbackHeaderImage: icons.placeHolderGames,
    fillColors: myGamesFills,
    type: 'activities',
    childrenPaths: ['/familyavatars'],
  },
  stories: {
    id: '20', // Using the same one as story since we load the same categories on the /stories tab (other than temple when there it is a temple share)
    testId: 'dataTestIdStories',
    paths: ['/stories', '/'],
    title: 'nav.stories',
    fallbackHeaderImage: '',
    fillColors: myFamilyFills,
    type: 'stories',
  },
  temple: {
    id: '40',
    testId: 'dataTestIdMyTemple',
    paths: ['/temple'],
    title: 'nav.my-temple',
    fallbackHeaderImage: icons.placeholderTemple,
    fillColors: myTempleFills,
    type: 'temple',
  },
  more: {
    id: '',
    testId: 'dataTestIdMore',
    paths: ['/more'],
    title: 'nav.more',
    fallbackHeaderImage: null,
    fillColors: myTempleFills,
    childrenPaths: ['/notifications'],
  },
}
